<template>
  <div>
    <all-products></all-products>
  </div>
</template>

<script>
import AllProducts from '@/components/products/AllProducts.vue';

export default {
  name: 'ShopPage',
  components: {
    AllProducts
  }
}
</script>

<style scoped>

</style>